var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"kiva-customer-portal"},[_c('v-progress-linear',{staticClass:"global-loader",attrs:{"color":"primary","active":_vm.isLoading,"indeterminate":"","absolute":"","bottom":"","height":"4"}}),_c(_vm.getLayout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }